import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, observeResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { Usuario } from "./usuario";
import { Session } from "./session";

const controller = rpcController("Turno");

export const Turno = cacheResource({
    /**
         * Marca tomo terminado un turno
         * @param id 
         */
    FinalizarTurno: async (idTurno: number): Promise<void> => await controller('FinalizarTurno', { idTurno }),

    /**
     * Obtiene una entidad
     * @param id Id de la entidad
     */
    Get: async (id: number): Promise<models.TurnoDto> => await controller('Get', { id }),

    /**Obtiene todas las entidades filtradas por la zona */
    Query: async (filtro: models.FiltroTurno): Promise<models.TurnoDto[]> => await controller('Query', {}, filtro),

    /**Agrega una entidad */
    CrearTurno: async (model: models.NuevoTurnoModel): Promise<number> => await controller('CrearTurno', {}, model),

    /**Obtiene el ultimo turno iniciado del usuario */
    UltimoTurno: async (idUsuario: number): Promise<models.TurnoDto> => await controller('UltimoTurno', { idUsuario }),


    VerCorte: async (idTurno: number): Promise<models.SaldosCaja> => await controller('VerCorte', { idTurno }),

    GenerarReporteCorte: async (idTurno: number): Promise<string> => await controller('GenerarReporteCorte', { idTurno }),

    /**Obtiene el reporte de resumen de turno para cierto turno */
    ReporteResumenTurno: async (idTurno: number): Promise<string> => await controller('ReporteResumenTurno', { idTurno }),
}, {
        Get: true,
        Query: true

    }, {
        CrearTurno: true,
        FinalizarTurno: true
    });

addOnInvalidateHandler(Turno, () => invalidateResource(Usuario));
addOnInvalidateHandler(Turno, () => invalidateResource(Session));


// WEBPACK FOOTER //
// ./app/resources/items/turno.ts